import { Paper as MuiPaper } from '@mui/material';
import { styled } from '@mui/material/styles';

// TODO: use this Paper component for the whole app not from MUI
export const Paper = styled(MuiPaper)({
  borderRadius: '16px',
});
